import { API_BASE } from "@/lib/api";
import { toast } from "sonner";

const esEscritorio = () => window.matchMedia?.("(pointer: fine)").matches && !/Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

// Abre un blob en pestaña nueva; si Chrome bloquea la ventana, ofrece un botón (clic real del usuario).
const abrirBlob = (url, nativeOpen) => {
  const w = nativeOpen(url, "_blank");
  if (!w) toast("Archivo listo", { duration: 20000, action: { label: "Abrir", onClick: () => nativeOpen(url, "_blank") } });
  return w;
};

/**
 * Escritorio: Chrome bloquea en silencio descargas/ventanas que ocurren después de esperar al servidor
 * ("descargas automáticas" / ventanas emergentes). Se mantiene la descarga normal y además se muestra
 * un botón "Descargar" que siempre funciona porque lo dispara un clic real. Celular: sin cambios.
 */
export const instalarDescargasEscritorio = () => {
  if (!esEscritorio() || window.__descargasOk) return;
  window.__descargasOk = true;
  const nativeClick = HTMLAnchorElement.prototype.click;
  const nativeOpen = window.open.bind(window);
  HTMLAnchorElement.prototype.click = function () {
    const href = this.href || "";
    if (this.download && href.startsWith("blob:") && !this.dataset.manual) {
      const name = this.download;
      nativeClick.call(this);
      toast.success(`Archivo listo: ${name}`, {
        duration: 20000,
        action: { label: "Descargar", onClick: () => {
          const a = document.createElement("a");
          a.href = href; a.download = name; a.dataset.manual = "1";
          document.body.appendChild(a); nativeClick.call(a); a.remove();
        } },
      });
      return;
    }
    nativeClick.call(this);
  };
  window.open = (url, ...rest) => (typeof url === "string" && url.startsWith("blob:") ? abrirBlob(url, nativeOpen) : nativeOpen(url, ...rest));
};

const authFetch = async (path, body) => {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API_BASE}${path}`, {
    method: body ? "POST" : "GET",
    headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(body ? { "Content-Type": "application/json" } : {}) },
    body: body ? JSON.stringify(body) : undefined,
    credentials: "include",
  });
  if (!res.ok) {
    const detail = await res.json().then((j) => j?.detail).catch(() => null);
    throw new Error(typeof detail === "string" ? detail : "No se pudo generar el archivo");
  }
  return res.blob();
};

export const descargar = async (path, filename, body) => {
  const blob = await authFetch(path, body);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 60000);
};

// Imprime un PDF del backend con un iframe oculto (sin ventanas emergentes).
export const imprimirPdf = async (path) => {
  const blob = await authFetch(path);
  const url = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
  if (esEscritorio()) {
    // Escritorio: el visor de PDF de Chrome no imprime desde un iframe oculto; se abre en pestaña nueva.
    abrirBlob(url, window.open.bind(window));
    setTimeout(() => URL.revokeObjectURL(url), 600000);
    return;
  }
  const iframe = document.createElement("iframe");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0";
  iframe.src = url;
  iframe.onload = () => {
    try { iframe.contentWindow.focus(); iframe.contentWindow.print(); } catch { window.open(url, "_blank"); }
    setTimeout(() => { iframe.remove(); URL.revokeObjectURL(url); }, 120000);
  };
  document.body.appendChild(iframe);
};
